<div class="tile-slider">
    <div class="slider-header">
        <!-- <bg-favourite
            class="favorite-icon"
            [RoomId]="RoomId"
            [roomName]="roomName"
            [bingoType]="bingoType"
            [isFavourite]="isFavourite"
            [favAddClass]="'favorite-added'"
            [favIcon]="favIcon"
            [favMarkedIcon]="favMarkedIcon"
            [favRemClass]="'favorite-removed'"
            *ngIf="IsFavouriteEnabled">
        </bg-favourite> -->

        <span class="close-icon" [ngClass]="isCozyUser ? 'theme-close-small' : 'theme-ex'" (click)="onSliderClose()"></span>
    </div>
    <div class="content">
        <div class="title-section">
            @if (isTitle) {
                <span class="ball-type-container">
                    <img src="{{ getBallTypeIconPath() }}" class="ball-type-icon" />
                </span>
            } @else {
                <bg-feature-icon [feature]="feature" [isNewBingoTile]="true"></bg-feature-icon>
            }

            <span class="title">{{ featureTitle || feature.replaceAll('_', ' ') }}</span>
        </div>
        <div class="description" id="slider-desc">
            {{ featureContent }}
        </div>
    </div>
</div>
